import executeWhenFinishToRender from 'core/renders/executeWhenFinishToRender'
import updateZipFormFromData from 'core/controllers/zipSearchHandler'
import getLandingContent from 'core/services/getLandingContent'
import setScrollToHandler from 'core/DOM/setScrollToHandler'
import individualState from 'core/DOM/individualState'
import updateContent from 'core/DOM/updateContent'

function initDOM({ hcStorage }) {
  // window.hc.smartlySDK is used safely because initPage() was executed before
  const smartlySDK = window.hc.smartlySDK
  if (smartlySDK) {
    smartlySDK.track('ph_display_landing')
    smartlySDK.publish()
  }
  getLandingContent().then(updateContent)
  updateZipFormFromData({ hcStorage })

  if (hcStorage.location.state_acronym) {
    individualState(hcStorage.location.state_acronym)

    setScrollToHandler()
  }

  executeWhenFinishToRender(hcStorage)
}

export default initDOM
